import React from "react";
import { humanize, opportunityTier, readDesiredOutcome } from "../strategyShape";
import {
	GreenCheckIcon,
	InfoHint,
	OPPORTUNITY_BADGE_CLASS,
	ScoreRing,
	SectionLabel,
} from "./shared";

export default function OpportunityScoreCard({ strategy }) {
	const scoreTier = opportunityTier(strategy.opportunity.score);
	const desiredOutcome = readDesiredOutcome(strategy.desired_outcome);
	const hasGoalContent =
		desiredOutcome &&
		(desiredOutcome.primary ||
			desiredOutcome.targetPosition !== null ||
			desiredOutcome.secondaryGoal ||
			desiredOutcome.featureAssociations.length > 0);

	return (
		<div className="monitoring__analysis-strategy-card monitoring__analysis-strategy-row-card monitoring__analysis-strategy-context-card">
			<div className="monitoring__analysis-strategy-card-head">
				<div className="d-flex align-items-center gap-1">
					<SectionLabel>Opportunity Score</SectionLabel>
					<InfoHint text="How winnable this prompt is for the brand — not current visibility." />
				</div>
			</div>
			<div className="monitoring__analysis-strategy-card-body">
				<div className="d-flex align-items-center gap-3">
					<ScoreRing score={strategy.opportunity.score} tier={scoreTier} />
					<div>
						<span
							className={`monitoring__analysis-strategy-eligible-badge ${OPPORTUNITY_BADGE_CLASS[scoreTier]}`}
						>
							{strategy.opportunity.eligible
								? "Eligible for action"
								: "Not eligible"}
						</span>
						<p className="small text-muted fst-italic mb-0 mt-1">
							How winnable this prompt is for the brand — not current visibility.
						</p>
					</div>
				</div>
				<p className="small text-muted mb-0 mt-3">{strategy.opportunity.reason}</p>

				<div className="monitoring__analysis-strategy-context-section monitoring__analysis-strategy-goal">
					<div className="monitoring__analysis-strategy-goal-panel">
						<p className="monitoring__analysis-strategy-goal-label mb-1">Goal</p>
						{hasGoalContent ? (
							<>
								{desiredOutcome.primary && (
									<p className="monitoring__analysis-strategy-goal-primary mb-2">
										{humanize(desiredOutcome.primary)}
									</p>
								)}
								{desiredOutcome.targetPosition !== null && (
									<p className="small text-muted mb-2">
										Target avg. position across providers: #{desiredOutcome.targetPosition}
									</p>
								)}
								{desiredOutcome.secondaryGoal && (
									<p className="small text-muted mb-2">
										Also: {humanize(desiredOutcome.secondaryGoal)}
									</p>
								)}
								{desiredOutcome.featureAssociations.length > 0 && (
									<div>
										<p className="small text-muted mb-2">Build association with:</p>
										<ul className="monitoring__analysis-strategy-source-type-list mb-0">
											{desiredOutcome.featureAssociations.map((f) => (
												<li key={f}>
													<GreenCheckIcon />
													<span>{f}</span>
												</li>
											))}
										</ul>
									</div>
								)}
							</>
						) : (
							<p className="small text-muted mb-0">No goal specified for this analysis.</p>
						)}
					</div>
				</div>
			</div>
		</div>
	);
}
